import { makeCygnusApiCall } from "../../../../../api/api";

/**
 * Fetch document files for the client
 * @param setFileInputs
 * @param setDocumentTypesApiProgress
 */
export const fetchDocumentForClient = async (
  clientMasterId: number,
  setDocumentFetchApiProgress: (arg: boolean) => void,
  referenceDataCode?: string | undefined,
  clientDocumentId?:  number | undefined,
) => {
  setDocumentFetchApiProgress(true);
  const response = await makeCygnusApiCall({
    type: "GET",
    payload: {},
    url: `/client_documents/?ClientMasterId=${clientMasterId}&ClientDocumentId=${""}&DocumentTypeCode=${referenceDataCode}`,
    show_message: true,
    customized_success_message: "Fetched document.",
    customized_failure_message:
      "Unable to fetch your document, please try again. If the problem persists, please contact support and attach a screenshot.",
    customized_error_message:
      "Error occured while fetching your document, please contact support and attach a screenshot.",
    isblob: false,
    forMDM: true,
  });
  if (response.success) {
    setDocumentFetchApiProgress(false);
    return response?.data;
  }
  setDocumentFetchApiProgress(false);
};
